import { telephone } from "@simplybusiness/icons";
import { Icon, LinkButton, Text } from "@simplybusiness/mobius";
import { Title } from "./Title";
import { OpeningHours } from "./OpeningHours";
import { Underline } from "../shared/Underline";
import type { FooterProps } from "./types";

export type SupportProps = Pick<FooterProps, "openingHours" | "phoneNumber">;

export const Support = (props: SupportProps) => {
  const { openingHours, phoneNumber } = props;

  return (
    <div className="mobius-footer__support">
      {phoneNumber && (
        <>
          <Title>
            Need help?{" "}
            <span className="mobius-footer__heading-partial">Call us</span>
          </Title>
          <LinkButton
            size="sm"
            href={`tel:${phoneNumber}`}
            className="mobius-footer__call-us-link"
          >
            <Icon icon={telephone} size="xs" title="Call support" />
            Call us
          </LinkButton>
          <Text
            variant="h3"
            elementType="p"
            className="mobius-footer__phone-number"
          >
            {phoneNumber}
            <Underline className="mobius-footer__phone-number-underline" />
          </Text>
        </>
      )}
      <OpeningHours openingHours={openingHours} />
    </div>
  );
};
